import * as React from 'react'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { parse, stringify } from 'querystring'
import { NEW_VERSION, OLD_VERSION, VERSION_COOKIE_KEY } from 'lib/version'
import Link from 'next/link'
import Cookies from '@arsenal/arsenal/modules/Cookies'
import { GlobalStoreContext } from 'Components/store'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'
import useShouldShowEntrance from './hooks/use-should-show-entrance'

// 入口开发开关
const onOff = true

// 新老版本切换
export const switchNewOrOld = (version = NEW_VERSION) => {
  const isNew = version === NEW_VERSION
  const versionKey = isNew ? NEW_VERSION : OLD_VERSION
  sendTeaCommEvent('clk_event', {
    event_id: 'right_float_nav',
    button_name: isNew ? '体验新版首页' : '返回旧版',
  })
  if (window?.location?.search) {
    try {
      const param = parse(window?.location?.search?.slice(1))
      param[VERSION_COOKIE_KEY] = versionKey

      window.location.href = `${window.location.origin}?${stringify(param)}`
      return
    } catch (error) {
      console.error(error)
    }
  }

  window.location.href = `${window.location.origin}?${VERSION_COOKIE_KEY}=${versionKey}`
}

export default function SwitchButton({ new_home = true }) {
  const shouldShowEntrance = useShouldShowEntrance()

  if (!onOff) {
    return null
  }

  if (!shouldShowEntrance) {
    return null
  }

  const switchToNewClick = () => {
    switchNewOrOld(new_home ? 'old' : 'new')
  }
  function renderSwith() {
    return (
      <div
        onClick={switchToNewClick}
        className={`switch-button ${
          new_home ? 'button-to-old' : 'button-to-new'
        }`}
      >
        <span className={new_home ? 'icon-to-old' : 'icon-to-new'} />
        {new_home ? '返回旧版' : '体验新版首页'}
        <style jsx>
          {`
            .switch-button {
              position: fixed;
              bottom: 8px;
              right: 8px;
              width: ${new_home ? 108 : 136}px;
              height: 44px;
              border: 0;
              outline: 0;
              text-align: left;
              border-radius: 4px;
              cursor: pointer;
              font-size: 14px;
              z-index: 9999;
              color: #fff;
              line-height: 44px;
              font-size: 14px;
              font-weight: 500;
            }
            .button-to-new {
              background-image: linear-gradient(252deg, #ff893f, #ee6512 1%);
            }
            .button-to-new:hover {
              background-image: linear-gradient(252deg, #e9732a, #d35910 1%);
            }
            .button-to-old {
              background-color: #c9cbd6;
            }
            .button-to-old:hover {
              background-color: #979aa8;
            }
            .icon-to-old {
              display: inline-block;
              width: 24px;
              height: 24px;
              margin: 0 4px 0 12px;
              background: url(${require('static/switch-to-new-white.png')})
                no-repeat center / 24px 24px;
            }
            .icon-to-new {
              display: inline-block;
              width: 36px;
              height: 44px;
              margin: 0 4px 0 0;
              background: url(${require('static/jiantou.gif')}) no-repeat center /
                36px 42px;
            }
            .switch-button:hover .icon-to-new {
              background: url(${require('static/jiantou-hover.gif')}) no-repeat
                center / 36px 42px;
            }
            p {
              color: #1a1a1a;
            }
          `}
        </style>
      </div>
    )
  }
  return <>{renderSwith()}</>
}
